import { forwardRef } from 'react';
import { format } from 'date-fns';
import { PdfReportHeaderProps } from './PdfReportHeader.props';
import {
  BlueLine,
  CompanyName,
  GeneratedText,
  HeaderContainer,
  LogoImage,
  MainHeader,
  RightSection,
} from './PdfReportHeader.styles';

const PdfReportHeader = forwardRef<HTMLDivElement, PdfReportHeaderProps>(({ reportOnly, title, 'data-ref': dataRef }, ref) => {
  const currentDateTime = format(new Date(), 'MM/dd/yyyy hh:mm a');

  return (
    <HeaderContainer ref={ref} reportOnly={reportOnly} data-ref={dataRef}>
      <MainHeader>
        <LogoImage src="/images/logos/scalar-logo.svg" alt="Scalar Logo" />
        <RightSection>
          <CompanyName>{title}</CompanyName>
          <BlueLine />
        </RightSection>
        <GeneratedText>Generated {currentDateTime}</GeneratedText>
      </MainHeader>
    </HeaderContainer>
  );
});

PdfReportHeader.displayName = 'PdfReportHeader';

export default PdfReportHeader;
